export default "__VITE_ASSET__BUZc9slG__"